const moneyIsBiggerThan = {
  computesRequired: true,
  getMessage: field => 'O campo ' + field + ' deve ser positivo',
  validate (value, { min }) {
    const formatedValue = value.replace('R$ ', '').replace(',', '.')
    const formatedMin = min.replace('R$ ', '').replace(',', '.')
    return +formatedValue > formatedMin
  }
}

export default moneyIsBiggerThan



// WEBPACK FOOTER //
// ./src/customValidators/moneyIsBiggerThan.js